/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiClient {
  private httpClient = inject(HttpClient);
  private httpBackend = inject(HttpBackend);
  private backendHttpClient = new HttpClient(this.httpBackend);

  public get<T>(url: string, params?: HttpParams, additionalHeaders?: HttpHeaders): Observable<T> {
    return this.httpClient.get<T>(url, {
      headers: additionalHeaders,
      responseType: 'json',
      params: params,
    });
  }

  public put<T>(url: string, body: any | null, params?: HttpParams, additionalHeaders?: HttpHeaders): Observable<T> {
    return this.httpClient.put<T>(url, body, {
      headers: additionalHeaders,
      responseType: 'json',
      params: params,
    });
  }

  public post<T>(url: string, body: any | null, params?: HttpParams, additionalHeaders?: HttpHeaders): Observable<T> {
    return this.httpClient.post<T>(url, body, {
      headers: additionalHeaders,
      responseType: 'json',
      params: params,
    });
  }

  public delete<T>(url: string, params?: HttpParams, additionalHeaders?: HttpHeaders): Observable<T> {
    return this.httpClient.delete<T>(url, {
      headers: additionalHeaders,
      responseType: 'json',
      params: params,
    });
  }

  public putAssetToS3(url: string, payload: any, additionalHeaders?: HttpHeaders): Observable<HttpResponse<any>> {
    return this.backendHttpClient.put<any>(url, payload, {
      headers: additionalHeaders,
      responseType: 'json',
    });
  }
}
